module.exports = __webpack_public_path__ + "img/button_profile.4996ff1b.png";